import { render } from "./HarvestDashboardBanner.vue?vue&type=template&id=b8168d56"
import script from "./HarvestDashboardBanner.vue?vue&type=script&lang=js"
export * from "./HarvestDashboardBanner.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__